

import * as moment from 'moment'

export class DataHoraHelp {

  data1EhMaiorQueData2(dataString1: any, dataString2: any): boolean {
    const data1 = moment(moment(dataString1).format("YYYY-MM-D HH:mm:ss"));
    const data2 =moment(moment(dataString2).format("YYYY-MM-D HH:mm:ss"));

    const diff = data1.diff(data2);
    return diff > 0;
  }
  data1EhMaiorOuIgualQueData2(dataString1: any, dataString2: any): boolean {
    const data1 = moment(dataString1);
    const data2 = moment(dataString2);

    const diff = data1.diff(data2);
    return diff >= 0;
  }

  data1EhIgualData2(dataString1: any, dataString2: any): boolean {
    const data1 = moment(dataString1);
    const data2 = moment(dataString2);

    const diff = data1.diff(data2);
    return diff == 0;
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/utils/data_hora_help.ts